import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL + "/admin/clients";

const getClientDetails = (clientId) => {
    return axios.get(API_URL + "/" + clientId, { headers: authHeader() });
};

const updateClientDetails = (clientId, detailsData) => {
    return axios.put(API_URL + "/" + clientId, detailsData, { headers: authHeader() });
};

const getReferenceData = () => {
    return axios.get(API_URL + "/reference-data", { headers: authHeader() });
};

const pkClientService = {
    getClientDetails,
    updateClientDetails,
    getReferenceData
};

export default pkClientService;
